import { useQuery } from '@tanstack/react-query';
import { handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { IUserData } from '@/lib/interface';
import routes from '@/lib/routes';
import dayjs from 'dayjs';

type TParams = {
  userId: string;
};
type TResponseData = IUserData;

export const useRequestGetUserData = (params?: TParams, run = true) => {

  const { invalidate } = useInvalidateQueries();
  const { isFetching: isLoadingUserData, data, error } = useQuery({
    queryKey: [routes.api.users.base, routes.api.users.find, params, run],
    queryFn: ({ queryKey: [_, _url, _params, _run] }) =>
      !_run || !(_params as TParams)?.userId
        ? Promise.resolve(null)
        : fetchQuery(_url as string, _params as TParams)
  });

  const userData = (data ?? null);

  const fetchQuery = (url: string, params: TParams) =>
    apiClient
      .get<TResponseData>(url, params)
      .then(handleApiResponse)
      .then(
        data =>
          data
            ? ({
              ...data,
              createdAt: dayjs(data.createdAt).toDate()
            })
            : data
      );

  const fetchUserData = (params: TParams) =>
    fetchQuery(routes.api.users.find, params);

  const refresh = () =>
    invalidate(routes.api.users.base, routes.api.users.find);

  return ({
    isLoadingUserData,
    fetchUserData,
    userData,
    refresh,
    error
  });

};
